'use client';

import React, { createContext, useContext } from 'react';

const useParentPage = (parentProps) => parentProps;

type ParentPageContextType = ReturnType<typeof useParentPage>;

export const ParentPageContext = createContext<ParentPageContextType>(null);

export const useParentPageContext = () => {
  const context = useContext(ParentPageContext);
  if (!context) {
    throw new Error('useParentPageContext must be used within the ParentPageContext');
  }
  return context;
};

interface IProps {
  parentProps?,
  children: React.ReactNode,
}

const ParentPageContextProvider = ({ children, parentProps }: IProps) => (
  <ParentPageContext.Provider value={ useParentPage(parentProps) }>
    { children }
  </ParentPageContext.Provider>
);

export default ParentPageContextProvider;
